module.exports = __webpack_public_path__ + "static/media/logo.a8b48cec.png";